import React from "react";
import { withRouter } from "react-router";

import {
  FechaDeGrupo,
  HistrorialProps,
  RegistroHistórico,
} from "src/utils/interfaces";
import {
  compararHistorialFecha,
  conseguirGrupoDeFechasActual,
} from "src/utils/fechas";

import RegistroHistorial from "src/components/Historial/RegistroHistorial";
import CabeceraFechaHistorial from "src/components/CabeceraFecha";

const Historial: React.FC<HistrorialProps> = (props: HistrorialProps) => {
  return (
    <>
      {props.registros.map((registro, idx) => {
        let registroAnterior: RegistroHistórico | null = null;

        if (idx !== 0) registroAnterior = props.registros[idx - 1];

        const sinCabecera =
          registroAnterior &&
          compararHistorialFecha(registro, registroAnterior) === 0;

        const grupoDeFechasActual = sinCabecera
          ? undefined
          : conseguirGrupoDeFechasActual(props.fechasDeGrupos, registro);

        return (
          <React.Fragment key={registro.id}>
            {!sinCabecera && (
              <CabeceraFechaHistorial
                {...(grupoDeFechasActual as FechaDeGrupo)}
              />
            )}

            <RegistroHistorial   {...registro} cargo={props.cargo} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default withRouter(Historial);
